import { css, Global } from '@emotion/react';
import React from 'react';
import { GlobalStyles as BaseStyles } from 'twin.macro';
import './override-scrollbar.css';
import './override-tabs.css';
import './override-time-picker.css';
import SVGColor from './svg-color';

const customStyles = css([
  {
    body: {
      backgroundColor: '#f3f3f3',
    },
  },
]);

const GlobalStyles = (): React.ReactElement => (
  <>
    <BaseStyles />
    <Global styles={customStyles} />
    <SVGColor />
  </>
);

export default GlobalStyles;
